import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LoginUiAlertConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isLastLoginDateAndTimeSecondsEnabled(): boolean {
		return this.configService.get((x) => x.common.login?.loginUiAlert?.isLastLoginDateAndTimeSecondsEnabled, false);
	}
}
